import { useTranslation } from "react-i18next";
import SelectField from "./SelectField";

/** Backend values (Post::FUNNEL_STAGES) and their short labels. */
export const FUNNEL_STAGES = [
  { value: "tofu", key: "Tofu", fallback: "TOFU · Awareness" },
  { value: "mofu", key: "Mofu", fallback: "MOFU · Consideration" },
  { value: "bofu", key: "Bofu", fallback: "BOFU · Conversion" },
];

/** Short badge text for a stored stage, or null when the post has none. */
export const funnelStageLabel = (stage, t) => {
  const found = FUNNEL_STAGES.find((s) => s.value === stage);
  return found ? t(`Backend.Post.FunnelStage.Short.${found.key}`, found.value.toUpperCase()) : null;
};

/**
 * Where the post sits in the marketing funnel. Optional: the empty choice
 * stores null, and the badge on the cards is hidden then.
 */
const FunnelStageSelect = ({ formik }) => {
  const { t } = useTranslation();
  return (
    <SelectField
      formik={formik}
      label={t("Backend.Post.FunnelStage.Title", "Funnel stage")}
      valueName={"funnel_stage"}
      value={formik.values.funnel_stage ?? ""}
      onChange={(e) => formik.setFieldValue("funnel_stage", e.target.value === "" ? null : e.target.value)}
    >
      <option value="">{t("Backend.Post.FunnelStage.None", "Not set")}</option>
      {FUNNEL_STAGES.map((s) => (
        <option key={s.value} value={s.value}>{t(`Backend.Post.FunnelStage.${s.key}`, s.fallback)}</option>
      ))}
    </SelectField>
  );
};

export default FunnelStageSelect;
